import api from './api';

export const weddingService = {
  async getWeddings(organizationId) {
    const response = await api.get(`/api/weddings?organization_id=${organizationId}`);
    return response.data;
  },

  async getMyWeddings() {
    const response = await api.get('/api/weddings/my-weddings');
    return response.data;
  },

  async getWedding(weddingId) {
    const response = await api.get(`/api/weddings/${weddingId}`);
    return response.data;
  },

  async createWedding(organizationId, weddingData) {
    const response = await api.post(`/api/weddings?organization_id=${organizationId}`, weddingData);
    return response.data;
  },

  async updateWedding(weddingId, weddingData) {
    const response = await api.put(`/api/weddings/${weddingId}`, weddingData);
    return response.data;
  },

  async deleteWedding(weddingId) {
    const response = await api.delete(`/api/weddings/${weddingId}`);
    return response.data;
  }
};
